import React from 'react';
import PropTypes from 'prop-types';

const PodcastOverlayContent = (props) => {
  const {
    data,
    envData,
    handleLogin,
    registrationTracking
  } = props;

  const textTitle = data.overlayTitle ? data.overlayTitle : 'Subscribe now to listen and unlock more.';
  const textDesc = data.overlayDesc ? data.overlayDesc : 'There\'s more to this podcast.';

  const handleSubscribe = () => {
    registrationTracking('subscribe', { events: [ 'event10' ] });

    const siteEnv = (siteID) => {
      switch (siteID) {
      case 'adv': return { desktop: 'AAWEB_WRE170_a_POD', mobile: 'AAWEB_MRE170_a_POD' };
      case 'cm': return { desktop: 'CMWEB_WRE170_a_POD', mobile: 'CMWEB_MRE170_a_POD' };
      case 'dt': return { desktop: 'DTWEB_WRE170_a_POD', mobile: 'DTWEB_MRE170_a_POD' };
      case 'hs': return { desktop: 'HSWEB_WRE170_a_POD', mobile: 'HSWEB_MRE170_a_POD' };
      case 'taus': return { desktop: 'TAWEB_WRE170_a_POD', mobile: 'TAWEB_MRE170_a_POD' };
      case 'twc': return { desktop: 'TCWEB_WRE170_a_POD', mobile: 'TCWEB_MRE170_a_POD' };
      case 'ntn': return { desktop: 'NTWEB_WRE170_a_POD', mobile: 'NTWEB_MRE170_a_POD' };
      case 'cp': return { desktop: 'CPWEB_WRE170_a_POD', mobile: 'CPWEB_MRE170_a_POD' };
      case 'tb': return { desktop: 'TBWEB_WRE170_a_POD', mobile: 'TBWEB_MRE170_a_POD' };
      case 'gcb': return { desktop: 'GCWEB_WRE170_a_POD', mobile: 'GCWEB_MRE170_a_POD' };
      case 'merc': return { desktop: 'TMWEB_WRE170_a_POD', mobile: 'TMWEB_MRE170_a_POD' };
      case 'ga': return { desktop: 'GAWEB_WRE170_a_POD', mobile: 'GAWEB_MRE170_a_POD' };
      case 'wtn': return { desktop: 'WTWEB_WRE170_a_POD', mobile: 'WTWEB_MRE170_a_POD' };
      default: return { desktop: 'WEB_WRE170_a_POD', mobile: 'WEB_MRE170_a_POD' };
      };
    };

    const baseUrl = envData.registration.site.baseUrl;
    const destUrl = envData.capiUrl;
    const deviceType = envData.device.toLowerCase() === 'mobile' ? 'mobile' : 'desktop';
    const sourceCode = siteEnv(envData.registration.site.id)[deviceType];

    const subscribeUrl = `${ baseUrl }/subscribe/news/1/?sourceCode=${ sourceCode }&dest=${ destUrl }&memtype=${ envData.userAccessLevel ? envData.userAccessLevel : 'anonymous' }&mode=premium`;
    if (envData.isAmp) {
      window.open(subscribeUrl, '_blank');
    } else {
      window.location.href = subscribeUrl;
    }
  };

  return (
    <div>
      <p>{ textDesc }</p>
      <h1>{ textTitle }</h1>
      { envData.site !== 'newscomau' &&
        <div className="et-common_registration_button" onClick={ handleSubscribe }>Sign Up</div>
      }
      { envData.site !== 'newscomau' && (
        <div className="et-common_text_terms">
          { envData.userAccessLevel !== 'registered' && typeof envData.userAccessLevel !== 'undefined' &&
            <span className="et-common_login_button" onClick={ handleLogin }>Log in</span>
          }
          <span>T&amp;Cs apply</span>
        </div>
      )}
    </div>
  );
};

PodcastOverlayContent.propTypes = {
  handleLogin: PropTypes.func.isRequired
};

export default PodcastOverlayContent;
